module.exports = __webpack_public_path__ + "static/media/susie_kim.dff8254b.png";